import React from 'react';
import classnames from 'classnames';

const ButtonGroup = ({
  children,
  theme,
  itemSpacingEnds = false,
  itemSpacingSides = true,
}) => {
  const classes = classnames('c-button-group', 'u-s-pb-small', {
    'c-button-group--inline': theme === 'inline',
  });

  const itemClasses = classnames('c-button-group__item', {
    'c-button-group__item--spacing-ends': itemSpacingEnds,
    'c-button-group__item--spacing-sides': itemSpacingSides,
  });

  return (
    <div className={classes}>
      {React.Children.map(children, child => {
        if (child) {
          return <div className={itemClasses}>{child}</div>;
        }
      })}
    </div>
  );
};

export default ButtonGroup;
